import { ALL_DENTAL } from 'core/constants/products'
import stickySummary from '../components/plan-summary/sticky'
import store from 'utils/store/withMiddleware'

function deleteDental(e: Event) {
  const state = store.getState()
  const addOns = state.addOns.filter(
    planId => !ALL_DENTAL.includes(state.plans[planId].productId)
  )

  store.update({ addOns, dentalPlanId: undefined })
  e.stopPropagation()
  e.preventDefault()
  stickySummary()
}

export default deleteDental
